import { Layout } from 'antd';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import Media from 'react-media';
import { usePromise } from 'react-use';

import { Spinner } from '../components/ui/spinner';
import { getAllowedRoutes } from '../routes';
import { SwitchRoutes } from '../routes/SwitchRoutes';
import { authService } from '../services/auth';
import { useAntdScope } from '../utils/hooks/useAntdScope';
import { showApiErrors } from '../utils/showApiErrors';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import styles from './Layout.module.css';

export const DashboardLayout = (): JSX.Element => {
  const [loading, setLoading] = useState(true);
  const mounted = usePromise();

  useAntdScope();

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        await mounted(authService.loadUserInfo());
      } catch (e) {
        showApiErrors(e as AxiosError);
      } finally {
        setLoading(false);
      }
    })();
  }, [mounted]);

  return (
    <div className={styles.layoutWrapper}>
      {loading ? (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
          <div className="flex items-center justify-center">
            <Spinner size="lg" centered />
          </div>
        </div>
      ) : (
        <Media query="(max-width: 599px)">
          {(isSmallScreen) => (
            <Layout style={{ minHeight: '100vh', zIndex: 2 }}>
              <Sidebar isSmallScreen={isSmallScreen} />

              <Layout>
                <Header />
                <Layout.Content style={{ margin: isSmallScreen ? '12px 12px 88px 12px' : '20px' }}>
                  <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <SwitchRoutes routes={getAllowedRoutes()} />
                  </div>
                </Layout.Content>
              </Layout>
            </Layout>
          )}
        </Media>
      )}
    </div>
  );
};
